import type { InputHTMLAttributes } from 'react'

const baseClasses =
  'w-full bg-paper dark:bg-navy/40 border border-carolina/20 dark:border-carolina/15 rounded-lg ' +
  'px-4 py-2.5 font-grotesk text-[15px] text-ink dark:text-cream ' +
  'placeholder:text-mist dark:placeholder:text-cream/30 ' +
  'focus:outline-none focus:border-carolina-dark dark:focus:border-carolina/60 ' +
  'focus:ring-2 focus:ring-carolina-dark/20 dark:focus:ring-carolina/20 ' +
  'disabled:opacity-50 transition-colors'

export const labelClasses = 'font-mono text-[14px] tracking-[2px] text-mist dark:text-cream/40'

type InputProps = {
  label?: string
} & InputHTMLAttributes<HTMLInputElement>

export function Input({ label, className = '', id, ...props }: InputProps) {
  if (label) {
    return (
      <div data-component="Input" className="space-y-1">
        <label htmlFor={id} className={labelClasses}>
          {label}
        </label>
        <input id={id} className={`${baseClasses} ${className}`} {...props} />
      </div>
    )
  }

  return (
    <input data-component="Input" id={id} className={`${baseClasses} ${className}`} {...props} />
  )
}
